import { Component, Input, OnInit } from "@angular/core";
import { Wiring } from "../../../../../codegen/out/types";

@Component({
  selector: "app-lt-wiring-diagram",
  templateUrl: "./lt-wiring-diagram.component.html",
  styleUrls: ["./lt-wiring-diagram.component.scss"],
  standalone: false,
})
export class LtWiringDiagramComponent implements OnInit {
  @Input() wiring: Wiring;

  terminals = {};

  ngOnInit(): void {
    for (const terminal of this.wiring.terminals) {
      this.terminals[terminal.device] = terminal;
    }
  }
}
